import { useEffect } from "react";
import HeroSection from "./components/HeroSection";
import ProblemsSection from "./components/ProblemsSection";
import AdvantagesSection from "./components/AdvantagesSection";
import SpeakerSection from "./components/SpeakerSection";
import AgendaSection from "./components/AgendaSection";
import AudienceSection from "./components/AudienceSection";
import RegistrationSection from "./components/RegistrationSection";
import SeminarScheduleSection from "./components/SeminarScheduleSection";
import FinalCtaSection from "./components/FinalCtaSection";
import SEOMeta from "@/components/feature/SEOMeta";

const siteUrl = (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) || "https://chronosspace.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "EducationEvent",
  "name": "自地自建說明講座｜速築美宅家 Chronos Space",
  "description": "120分鐘免費自地自建講座，涵蓋土地評估、建築設計、預算試算、報建法規、預製工法與室內軟裝整合。",
  "organizer": {
    "@type": "Organization",
    "name": "速築美宅家 Chronos Space",
    "url": siteUrl
  },
  "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
  "eventStatus": "https://schema.org/EventScheduled",
  "location": [
    {
      "@type": "Place",
      "name": "台中設計總部",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "台中市北區中清路一段79號6樓",
        "addressLocality": "台中市",
        "addressRegion": "台灣",
        "addressCountry": "TW"
      }
    }
  ],
  "inLanguage": "zh-TW",
  "about": ["自地自建", "危老重建", "預製工法", "鋼構住宅"],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "TWD",
    "availability": "https://schema.org/InStock",
    "validFrom": "2025-01-01"
  }
};

export default function Seminars() {
  useEffect(() => {
    document.title = "自地自建說明講座｜速築美宅家 Chronos Space";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "免費自地自建講座，帶你了解土地評估、建築設計、預算試算、報建法規、預製工法與室內軟裝整合。立即加入 LINE@ 預約。"
      );
    }
  }, []);

  return (
    <main>
      <SEOMeta
        title="自地自建說明講座"
        description="120分鐘免費自地自建講座，涵蓋土地評估、建築設計、預算試算、報建法規、預製工法與室內軟裝整合。立即加入 LINE@ 預約。"
        keywords="自地自建講座,自地自建說明會,預製工法講座,鋼構住宅說明會,免費建築講座"
        canonicalPath="/seminars"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <ProblemsSection />
      <AdvantagesSection />
      <SpeakerSection />
      <AgendaSection />
      <SeminarScheduleSection />
      <AudienceSection />
      <RegistrationSection />
      <FinalCtaSection />
    </main>
  );
}